import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RequestAccess } from '@app/interface/request.interface';
import { UserType } from '@app/_models/user-type';
import { AuthenticationService } from '@app/_services';
import { PropertyService } from '@app/_services/property.service';
import { UserTypeService } from '@app/_services/user-type.service';
import { environment } from '@environments/environment';
import { faPaperPlane, faQuestionCircle, faUser } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-request-access',
    templateUrl: './request-access.component.html',
    styleUrls: ['./request-access.component.css'],
    standalone: false
})
export class RequestAccessComponent implements OnInit {

  requestAccessForm!: FormGroup;

  loading = false;
  submitted = false;
  error = '';
  home = false;

  faPaperPlane = faPaperPlane;
  faQuestionCircle = faQuestionCircle;
  faUser = faUser;

  numberPattern = "^[0-9]{1,4}";
  accessPattern = "^[A-Z0-9a-z]{1}[0-9A-Za-z]{6,8}";
  indexPattern = "[0-9]";

  userTypes!: UserType[];

  constructor(public fb: FormBuilder, private propertyService: PropertyService, 
    private userTypeService: UserTypeService, 
    private authenticationService: AuthenticationService,
    private toastr: ToastrService) { 
    this.requestAccessForm = this.fb.group({
       propertyname: [{value: '', disabled: true}],
       propertyaddress: [{value: '', disabled: true}],
       username: [{value: '', disabled: true}],
       usernameValue: '',
       propertyid: [{value: ''}],
       index: ['', [Validators.required, Validators.pattern(this.numberPattern)]],
       accesskey:  ['', [Validators.required, Validators.pattern(this.accessPattern)]],
       usertype: [{value: '', disabled: true}, Validators.required]
    });

    //first: new FormControl({value: 'Nancy', disabled: true}, Validators.required)
  }

  ngOnInit(){
    this.userTypeService.getAll().pipe(first()).subscribe(usertypes => {
      this.userTypes = usertypes;
    });
    let currentUser = this.authenticationService.currentUserValue;
    //this.form.controls['name'].setValue(localStorage.getItem('community_name'));
    this.requestAccessForm.patchValue({ propertyname: localStorage.getItem('property_name')});
    this.requestAccessForm.patchValue({ propertyaddress: localStorage.getItem('property_address')});
    this.requestAccessForm.patchValue({ username: currentUser!.username});
    this.requestAccessForm.patchValue({ usernameValue: currentUser!.username });
    this.requestAccessForm.patchValue({ propertyid: localStorage.getItem("property_id")})
    if (localStorage.getItem("property_id") == '1000') {
      this.home = true;
    }
  }

  get f() { return this.requestAccessForm.controls; }

  get accessKey() {
    return this.requestAccessForm.get('accesskey');
  }


  submitForm() {

    this.submitted = true;
    if (!this.home) {
      this.requestAccessForm.get('index')!.setValue(0);
      this.requestAccessForm.get('accesskey')!.setValue('DEFAULT');
    }
    

    // stop here if form is invalid
    if (this.requestAccessForm.invalid) {
        this.toastr.info('Please fill out form correctly', 'Information');
        return;
    }

    this.loading = true;

    var data = this.requestAccessForm.value;
    if (!environment.production) {
      console.log('Form data', data);
    }
    let request: RequestAccess = {
      property_id: data.propertyid,
      username: data.usernameValue,
      channel: 'web',
      usertype: data.usertype,
      index: this.requestAccessForm.get('index')!.value,
      accesskey: this.requestAccessForm.get('accesskey')!.value
    };
    
    this.propertyService.requestAccess(request).subscribe(
      data => {
        this.toastr.success(data.message, 'Success');
        if (!environment.production) {
          console.log('Request access response',data);
        }   
      },
      error => {
        this.toastr.error(error, 'Failed');
        if (!environment.production) {
          console.log('Request access error', error);
        }
        
      }
    );

  }

}
